'use client';

import {
	Box, Text, useSlotRecipe,
} from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

type TitleProps = Omit<BoxProps, 'children'> & {
	children?: never
	title:     string
};

type ChildrenProps = BoxProps & {
	children: ReactNode
	title?:   never
};

type Props = ChildrenProps | TitleProps;

export const SectionTitle = (props: Props) => {
	const recipe = useSlotRecipe({ key: 'sectionTitle' });
	const styles = recipe();

	const content = 'title' in props ? props.title : props.children;

	const boxProps: BoxProps = 'title' in props
		? (({ title: _, ...rest }) => rest)(props)
		: (({ children: _, ...rest }) => rest)(props);

	return (
		<Box css={styles.root} {...boxProps}>
			<Text css={styles.text}>
				{content}
			</Text>
		</Box>
	);
};

;
